import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListCategoriesComponent } from './components/list-categories/list-categories.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AddCategoriesComponent } from './components/add-categories/add-categories.component';
import { UiModule } from 'src/app/ui/ui.module';



@NgModule({
  declarations: [
    ListCategoriesComponent,
    AddCategoriesComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    UiModule,
  ]
})
export class CategoriesModule { }
